export default "__VITE_ASSET__DVjPoThD__"